// @flow

import slugify from 'slugify';
import { cond, constant, has } from 'lodash/fp';

type SubCategory = {
  id: number,
  disabled: boolean,
  filterKey: string,
  filterValues: Array<number>,
  name: string,
  slug: string
};

function decodeSubcategory(item = {}): SubCategory {
  return {
    id: item.id,
    disabled: !item.active || item.active === '0',
    filterKey: cond([
      [has('competition_type_id'), constant('competitionId')],
      [has('sub_sport_id'), constant('subSportId')],
      [has('sport_id'), constant('sportId')]
    ])(item.filter),
    filterValues:
      item.filter.competition_type_id || item.filter.sub_sport_id || item.filter.sport_id,
    name: item.name,
    slug: slugify(item.name, { lower: true })
  };
}

export type SportCategory = {
  id: number,
  disabled: boolean,
  filterKey: string,
  filterValues: Array<number>,
  name: string,
  slug: string,
  icon: string,
  subcategories: Array<SubCategory>
};

function decodeCategory(item: Object = {}): SportCategory {
  return {
    ...decodeSubcategory(item),
    icon: item.icon,
    sport: item.sport_name,
    subcategories: item.subcategories.map(decodeSubcategory)
  };
}

export default decodeCategory;
